<ion-app>
  <app-notification-popup [notification]="notificationService.notification$ | async"></app-notification-popup>
  <app-global-loader></app-global-loader>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
